import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    paddingTop: 20,
    paddingBottom: 'max(env(safe-area-inset-bottom), 20px)',
    width: '100%',
    backgroundColor: theme.palette.background.membership,
  },
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
}));

export const OrganizationProFeaturesDownstate = (): JSX.Element => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.root}>
      <Container maxWidth="sm" className={classes.container}>
        <Stack spacing={3} sx={{ flex: 1 }}>
          <Typography variant="h3" align="center" fontWeight="fontWeightBold">
            {t('organizationProFeaturesDownstate.title')}
          </Typography>
          <Typography sx={{ lineHeight: '22px' }}>
            {t('organizationProFeaturesDownstate.description')}
          </Typography>
          <Typography sx={{ lineHeight: '22px' }}>
            {t('organizationProFeaturesDownstate.context')}
          </Typography>
          <Typography sx={{ lineHeight: '22px' }}>
            {t('organizationProFeaturesDownstate.suggestedAction')}
          </Typography>
        </Stack>
        <Button fullWidth size="large" component={Link} to="/">
          {t('organizationProFeaturesDownstate.button')}
        </Button>
      </Container>
    </Box>
  );
};
